var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import Vue from 'vue';
import moment from 'moment';
import Component from 'vue-class-component';
import { Watch } from 'vue-property-decorator';
import apiGateway, { ProjectCategory } from '@/api-gateway';
import ProjectList from '@/components/project-list/ProjectList.vue';
import { ImportExcel, ValidationRuleType } from '@/components/excel/';
import ProjectPreviewPanel from './components/ProjectPreviewPanel.vue';
import CreateProjectBtn from './components/CreateProjectBtn.vue';
import SelectedProject from './components/SelectedProject.vue';
import { genProjectName } from '@/utils/string';
import SubFilter from '@/components/SubFilter.vue';
var ProjectIndex = /** @class */ (function (_super) {
    __extends(ProjectIndex, _super);
    function ProjectIndex() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.projects = [];
        _this.previewId = 0;
        _this.isSelectToExport = false;
        _this.selectedProjects = [];
        _this.paginationSizes = [20, 50, 100];
        _this.selectedProjectsFromTable = [];
        _this.pagination = { limit: 50 };
        _this.serverTotalRows = 0;
        _this.search = '';
        _this.programDropdown = {
            projectCategory: '',
            formatOptions: '',
            projectRegionCode: []
        };
        _this.id_number = null;
        _this.validationRules = [
            {
                header: 'Project System ID',
                required: true,
                type: ValidationRuleType.INTEGER,
                unique: true
            },
            {
                header: 'Project Name',
                type: ValidationRuleType.STRING
            },
            {
                header: 'Project Category',
                type: ValidationRuleType.STRING
            },
            {
                header: 'Related Program',
                type: ValidationRuleType.STRING
            },
            {
                header: 'Related Property(TH)',
                type: ValidationRuleType.STRING
            },
            {
                header: 'Related Property(EN)',
                type: ValidationRuleType.STRING
            },
            {
                header: 'Target Approval Date',
                type: ValidationRuleType.DATE
            },
            {
                header: 'Target Site Hand Over',
                type: ValidationRuleType.DATE
            },
            {
                header: 'Target Grand Opening',
                type: ValidationRuleType.DATE
            },
            {
                header: 'Target Present Site',
                type: ValidationRuleType.DATE
            },
            {
                header: 'Target 1st CIA',
                type: ValidationRuleType.DATE
            },
            {
                header: 'Target TPM/AMD',
                type: ValidationRuleType.DATE
            },
            {
                header: 'Target Present Site Font Color',
                type: ValidationRuleType.STRING
            },
            {
                header: 'Target Present Site Icon Color',
                type: ValidationRuleType.STRING
            },
            {
                header: 'Target Approval Date Font Color',
                type: ValidationRuleType.STRING
            },
            {
                header: 'Target Approval Date Icon Color',
                type: ValidationRuleType.STRING
            },
            {
                header: 'Target Site Hand Over Font Color',
                type: ValidationRuleType.STRING
            },
            {
                header: 'Target Site Hand Over Icon Color',
                type: ValidationRuleType.STRING
            },
            {
                header: 'Target Grand Opening Font Color',
                type: ValidationRuleType.STRING
            },
            {
                header: 'Target Grand Opening Icon Color',
                type: ValidationRuleType.STRING
            },
            {
                header: 'Target 1st CIA Font Color',
                type: ValidationRuleType.STRING
            },
            {
                header: 'Target 1st CIA Icon Color',
                type: ValidationRuleType.STRING
            },
            {
                header: 'Target TPM/AMD Font Color',
                type: ValidationRuleType.STRING
            },
            {
                header: 'Target TPM/AMD Icon Color',
                type: ValidationRuleType.STRING
            },
            {
                header: 'First Layout Date',
                type: ValidationRuleType.DATE
            },
            {
                header: 'First Layout Date Font Color',
                type: ValidationRuleType.STRING
            },
            {
                header: 'First Layout Date Icon Color',
                type: ValidationRuleType.STRING
            },
            {
                header: 'Mall Leasing',
                type: ValidationRuleType.STRING
            },
            {
                header: 'Construction Progress',
                type: ValidationRuleType.STRING
            },
            {
                header: 'Mall Construction',
                type: ValidationRuleType.STRING
            }
        ];
        return _this;
    }
    Object.defineProperty(ProjectIndex.prototype, "selectedProjectsCount", {
        get: function () {
            return this.selectedProjects.length;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ProjectIndex.prototype, "userRole", {
        get: function () {
            return this.$store.state.AppActiveUser.userRole.split(', ');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ProjectIndex.prototype, "canImport", {
        get: function () {
            return (this.userRole.includes('VIP') ||
                this.userRole.includes('Program') ||
                this.userRole.includes('Acquisition') ||
                this.userRole.includes('Feasibility'));
        },
        enumerable: false,
        configurable: true
    });
    ProjectIndex.prototype.beforeMount = function () {
        return __awaiter(this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.fetchProjects(this.pagination)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    ProjectIndex.prototype.importProjects = function (excelData) {
        return __awaiter(this, void 0, Promise, function () {
            var resp, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, apiGateway.importProjects(excelData.results.map(function (result) { return ({
                                id: result.projectSystemId.value,
                                targetApproveDate: result.targetApprovalDate.value,
                                targetHandOverDate: result.targetSiteHandOver.value,
                                targetOpenDate: result.targetGrandOpening.value,
                                targetPresentSiteDate: result.targetPresentSite.value,
                                targetFirstCIADate: result.target1stCia.value,
                                targetTPMDate: result.targetTpmAmd.value,
                                targetApproveDate_Icon: result.targetApprovalDateIconColor.value,
                                targetApproveDate_Font: result.targetApprovalDateFontColor.value,
                                targetHandOverDate_Icon: result.targetSiteHandOverIconColor.value,
                                targetHandOverDate_Font: result.targetSiteHandOverFontColor.value,
                                targetOpenDate_Icon: result.targetGrandOpeningIconColor.value,
                                targetOpenDate_Font: result.targetGrandOpeningFontColor.value,
                                targetPresentSiteDate_Icon: result.targetPresentSiteIconColor.value,
                                targetPresentSiteDate_Font: result.targetPresentSiteFontColor.value,
                                targetFirstCIADate_Icon: result.target1stCiaIconColor.value,
                                targetFirstCIADate_Font: result.target1stCiaFontColor.value,
                                targetTPMDate_Icon: result.targetTpmAmdIconColor.value,
                                targetTPMDate_Font: result.targetTpmAmdFontColor.value,
                                firstLayoutDate: result.firstLayoutDate.value,
                                firstLayoutDate_Icon: result.firstLayoutDateIconColor.value,
                                firstLayoutDate_Font: result.firstLayoutDateFontColor.value,
                                mallLeasing: result.mallLeasing.value,
                                constructionProgress: result.constructionProgress.value,
                                mallConstruction: result.mallConstruction.value
                            }); }))];
                    case 1:
                        resp = _b.sent();
                        if (resp && resp.status === 200) {
                            ;
                            this.$refs.importExcel.closePopup();
                            this.$vs.notify({
                                color: 'success',
                                title: 'Successful Import'
                            });
                            this.fetchProjects(this.pagination);
                        }
                        else {
                            ;
                            this.$refs.importExcel.closePopup();
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        _a = _b.sent();
                        this.$vs.notify({
                            color: 'danger',
                            title: 'Import Failed'
                        });
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    ProjectIndex.prototype.exportProjects = function () {
        return __awaiter(this, void 0, Promise, function () {
            var resp, url, link;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, apiGateway.exportProjects(this.selectedProjects.map(function (projects) { return projects.id; }))];
                    case 1:
                        resp = _a.sent();
                        url = window.URL.createObjectURL(new Blob([resp.data]));
                        link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', "export_projects_" + moment().format('YYYYMMDD_HHmmss') + ".xlsx");
                        document.body.appendChild(link);
                        link.click();
                        return [2 /*return*/];
                }
            });
        });
    };
    ProjectIndex.prototype.onPaginationChanged = function (pagination) {
        this.pagination = pagination;
        this.fetchProjects(pagination, this.search);
    };
    ProjectIndex.prototype.onSearchQueryChange = function (search) {
        this.search = search;
        this.pagination.offset = 0;
        this.fetchProjects(this.pagination, search);
    };
    ProjectIndex.prototype.fetchProjects = function (pagination, search) {
        return __awaiter(this, void 0, Promise, function () {
            var subFilter, resp;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        subFilter = {
                            category: this.programDropdown.projectCategory,
                            format: this.programDropdown.formatOptions,
                            regional: this.programDropdown.projectRegionCode
                        };
                        return [4 /*yield*/, apiGateway.getProjectsBySubFilter(false, pagination, search, subFilter)];
                    case 1:
                        resp = _a.sent();
                        this.serverTotalRows = resp.data.total;
                        this.projects =
                            resp.data.rows.map(function (project) {
                                var name = genProjectName(project);
                                if (project.category === ProjectCategory.REBRANDING ||
                                    project.category === ProjectCategory.PLANNINGANDMALL) {
                                    return __assign(__assign({}, project), { name: name, format: __assign(__assign({}, project.format), { name: '' }), subFormat: __assign(__assign({}, project.subFormat), { name: '' }), type: __assign(__assign({}, project.type), { name: '' }), region: '' });
                                }
                                return __assign(__assign({}, project), { name: name });
                            }) || [];
                        return [2 /*return*/];
                }
            });
        });
    };
    ProjectIndex.prototype.outputValue = function (value) {
        this.programDropdown.projectCategory = value.projectCategory;
        this.programDropdown.formatOptions = value.formatOptions;
        this.programDropdown.projectRegionCode = value.projectRegionCode;
        this.fetchProjects(this.pagination);
    };
    ProjectIndex.prototype.onToggleSelectToExport = function () {
        this.previewId = 0;
        this.deleteAllSelectedProjects();
    };
    ProjectIndex.prototype.onSelectedRowChange = function (val) {
        var checkExist = {};
        var final = [];
        var allArray = __spreadArrays(this.selectedProjects, val);
        for (var _i = 0, allArray_1 = allArray; _i < allArray_1.length; _i++) {
            var project = allArray_1[_i];
            if (!checkExist[project.id]) {
                final.push(project);
                checkExist[project.id] = true;
            }
        }
        this.selectedProjects = __spreadArrays(final);
    };
    ProjectIndex.prototype.onRowClicked = function (row) {
        this.previewId = row.data.id;
    };
    ProjectIndex.prototype.deleteSelectedProject = function (index) {
        this.selectedProjects.splice(index, 1);
    };
    ProjectIndex.prototype.deleteAllSelectedProjects = function () {
        this.selectedProjects = [];
    };
    __decorate([
        Watch('isSelectToExport')
    ], ProjectIndex.prototype, "onToggleSelectToExport", null);
    ProjectIndex = __decorate([
        Component({
            components: {
                ProjectList: ProjectList,
                ProjectPreviewPanel: ProjectPreviewPanel,
                CreateProjectBtn: CreateProjectBtn,
                SelectedProject: SelectedProject,
                ImportExcel: ImportExcel,
                SubFilter: SubFilter
            }
        })
    ], ProjectIndex);
    return ProjectIndex;
}(Vue));
export default ProjectIndex;
